import { createFeatureSelector } from '@ngrx/store';
import {
  PASSENGER_INFO_INPUT_MODAL_STORE_NAME,
  PassengerInformationInputModalState,
} from './passenger-information-input-modal.state';

/** Select PassengerInformationInputModal State */
export const selectPassengerInformationInputModalState = createFeatureSelector<PassengerInformationInputModalState>(
  PASSENGER_INFO_INPUT_MODAL_STORE_NAME
);
